<template>
  <span v-if="isPlaceholder || !isNaN(value)">
    <span v-if="lang == 'en'">
        <small>
            <sup>{{ symbol }}</sup>
        </small>
        <span class="amount">{{ isPlaceholder ? value : numeral(value).format(format) }}</span>
        <small>
            <span v-if="!!months" style="font-size: 80%;">{{ `${trans('monthly_type', {
                nb_months: parseInt(months) == 1 ? '' : months,
                type: trans(type).toLowerCase()
            })}${parseInt(months) > 1 ? 's' : ''}` }}</span>
        </small>
    </span>
    <span v-if="lang == 'fr'">
        {{ isPlaceholder ? value : numeral(value).format(format) }}
        <small>
            <sup>{{ symbol }}</sup>
            <span v-if="!!months" style="font-size: 80%;">{{
            trans('monthly_type', {
                nb_months: parseInt(months) == 1 ? '' : months,
                type: trans(type).toLowerCase()
            })
            }}</span>
        </small>
    </span>
    </span>
</template>

<script>
  export default {
    props: {
      value: { // Pass in a number. Or, to put a placeholder, pass in a string starting with #. For example '###.##'
        type: Number | String,
        default: null,
      },
      format: {
        type: String,
        default: '0,000[.]00',
      },
      currency: String,
      months: {
        type: Number | String,
        default: null,
      },
      type: {
        type: String,
        default: 'month',
      }
    },
    data() {
      return {
        trans: trans,
        lang: window.lang,
        numeral: numeral,
      }
    },
    computed: {
      symbol() {
        let symbol = '$'
        if (this.currency == 'cad') symbol = 'CA$'
        if (this.currency == 'usd') symbol = 'US$'
        return symbol
      },
      isPlaceholder() {
        return (this.value + '').indexOf('#') === 0
      },
    },
  }
</script>
